import { text } from './ticket';

export const pt = {
  text,
};
